export function prepareNewRequestInfo (request, bodyFormData) {
  const controlConditions = [{
    code: undefined,
    name: 'BS1-BS5 Тестовое на все заявки',
    type: 'bs1Bs6',
    duration: 18000000,
    bp: 'requestBusinessProcess',
    firstState: 'BS1',
    lastState: 'BS6'
  }]

  const workTypesIds = []
  for (let i = 0; i < request.workTypes.length; i++) {
    workTypesIds.push(request.workTypes[i].id)
  }

  bodyFormData.set('typeId', request.requestType)
  bodyFormData.set('priority', request.requestPriority)
  bodyFormData.set('conditions', JSON.stringify(controlConditions))
  bodyFormData.set('workTypes', JSON.stringify(workTypesIds))

  if (request.serviceObject) {
    bodyFormData.set('objectId', request.serviceObject.id)
  }
}
